<template>
  <b-modal
    ref="bModal"
    :title="$t('global.scanPrintedTitleCase')"
    centered
    modal-class="scan-printed-label"
  >
    <b-row class="px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <div class="px-5 pb-3 pt-2 text-center d-flex flex-column">
          <i
            class="main-icon pb-3 far fa-scanner"
            aria-hidden="true"
          />
          <span class="title">{{ $t('global.scanPrintedSubtitleEntityCase') }} {{ $t('global.scanPrintedEnterCode') }}</span>
        </div>
        <div class="barcode-input">
          <b-input-group
            size="sm"
            class="mb-2 mr-sm-2 mb-sm-0"
          >
            <b-input-group-prepend>
              <b-input-group-text>
                <fa-icon :icon="['fal', 'barcode-alt']" />
              </b-input-group-text>
            </b-input-group-prepend>
            <vt-input
              v-model="externalLabel"
              class="form-control-sm"
            />
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <!-- TODO: Aparece solo cuando se guarda una plantilla nueva -->
          <b-button
            size="sm"
            class="d-none btn--primary mx-2"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </b-button>
          <b-button
            size="sm"
            class="btn--primary"
            @click="sendExternalLabel"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'

export default {
    name: 'ScanPrintedLabel',
    data() {
        return {
            externalLabel: ''
        }
    },
    computed: {
        caseRegex() {
            return this.$store.getters.regex.filter((regex) => regex.identifierType.idtScope === IDENTIFIER_SCOPES.CASE)
        }
    },
    methods: {
        show() {
            this.externalLabel = ''
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        sendExternalLabel() {
            for (let regex of this.caseRegex) {
                const caseRegexObject = new RegExp('^(?:' + regex.regex + ')$')
                if (caseRegexObject.test(this.externalLabel)) {
                    this.$emit('externalLabel', this.externalLabel)
                    return
                }
            }
            this.showErrorModalGlobal(this.$t('registry.errors.invalidCaseLabel'))
        }
    }
}

</script>

<style lang="scss">
    .scan-printed-label .main-icon {
        color: vt-color(primary);
        font-size: 25px;
    }
    .scan-printed-label .title {
        font-size: font-size(very-small) !important;
    }
    .scan-printed-label .modal-body {
        padding: 20px 10px;
    }
    .scan-printed-label .modal-dialog {
        max-width: 20%;
    }
    .scan-printed-label .barcode-input {
        border: 1px solid vt-color(grid-general-border);
        border-radius: 5px;
        height: 32px;
        padding-top: 1px;
    }
    .scan-printed-label .input-group-prepend .input-group-text {
        border-radius: 14px;
        color: vt-color(search-bar-text);
        border: none;
        background-color: inherit;
        font-size: 12px;
        padding-left: 12px;
    }
    .scan-printed-label input {
        width: 150px;
        border: none;
        color: vt-color(search-bar-text);
        background-color: inherit;
        font-size:1.1rem;
        padding-top:0.4rem;
    }

    @media (max-width: 1300px) {
        .scan-printed-label .modal-dialog {
            max-width: 30%;
        }
    }
</style>

<style lang="scss" scoped>
    .scan-printed-label span {
        font-size: font-size(very-normal);
    }
</style>
